import { Typography } from "@circle-react-uikit/Typography";

import { t } from "@/i18n-js/instance";

export const MarketingCampaignBanner = () => (
  <div className="relative overflow-hidden rounded-lg bg-black px-10 py-8">
    <div className="absolute left-[66px] top-[-336px] h-[380px] w-[947px] rounded-full bg-[#3655E5] blur-[107px]" />
    <div className="relative z-10 flex flex-row items-center gap-x-12">
      <div className="text-7xl font-extrabold text-white">
        {t("pricing_plans.marketing_campaign.banner.discount")}
      </div>
      <div>
        <Typography.TitleXl color="text-white">
          {t("pricing_plans.marketing_campaign.banner.title")}
        </Typography.TitleXl>
      </div>
    </div>
  </div>
);
